<template>
    <div class="c-mapbox-map__overlay" :class="{'c-mapbox-map__overlay--disabled': disabled}" @click.prevent="disabled = true">
        <div class="inner">
            <a href="#" class="btn-main">Click to Explore Map</a>
        </div>
    </div>
</template>

<script>
    import './_overlay.scss';
    export default {
        name: "overlay",
        data: function () {
            return {
                disabled: false
            };
        }
    };
</script>


// WEBPACK FOOTER //
// Assets/Scripts/Components/Mapbox/overlay/overlay.vue